import React from 'react'
import error from "../../src/assets/images/Not-Found.png";
import logo from "../../src/assets/images/logo.png"
import { Link } from 'react-router-dom';
import useLocalStorage from 'use-local-storage';



const NotFound = () => {
  const [isDark, setIsDark] = useLocalStorage("isDark", false);

  return (
    <>
      <div className="pt-5 pb-5">
        <div className="mt-4 mb-3 error-image-cont error-cont m-auto d-flex justify-content-center align-item-center">
          <img src={error} alt="404 Not Found" width={400} />
        </div>
        <div className="d-flex justify-content-center pt-2">
          <footer class="row "  >
            <div className="img text-center">
                {isDark ? (
                 <div id="logo" >
                   <Link to="/">
                    <img
                       className="site-logo"
                       id="trans-logo"
                       src={require('../../src/assets/images/logo2.png')}
                       alt="Image"
                       width={150}
                      />
                     </Link>
                    </div>
                  ) : (
                                        <div id="logo">
                                            <Link to="/">
                                                <img
                                                    className="site-logo"
                                                    id="trans-logo"
                                                    src={require('../../src/assets/images/logo.png')}
                                                    alt="Image"
                                                    width={150}
                                                />
                                            </Link>
                                        </div>
                                    )}              
                
              {/* <img src={logo} alt="JobKiKhoj" width={150}
              /> */}
              {/* // style="width:10%; height:auto;display: block; margin-left: auto; margin-right: auto;"  */}
            </div>
            <div class="setting text-center pt-2 f-20">
              <a href="/Home" >Go to Main Page</a>
            </div>

            {/* <p style="text-align: center; font-size: 20px; font-weight: 900;">Connect all the members globally to find better solutions for career path</p>         */}
          </footer>

        </div>

      </div>

    </>
  )
}

export default NotFound